// 角色管理
export default [{ // 租户角色
  path: '/roleManager',
  name: 'roleManager',
  component: resolve => require(['@/views/roleManager/roleManager.vue'], resolve),
  meta: {
    group: "/roleManager",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 角色管理
  path: '/opsRole',
  name: 'opsRole',
  component: resolve => require(['@/views/roleManager/opsRole.vue'], resolve),
  meta: {
    group: "/opsRole",
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/roleManager/roleManager.js